import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { Icon } from './icon-model';

export enum IncidentFormEnum {
  categoria = 'categoryId',
  subcategoria = 'subcategoryId',
  medio = 'mediaId',
  impact = 'impactId',
  involvedAmount = 'involvedAmount',
  estado = 'stateId',
  situacion = 'situationId',
  source = 'sourceId',
  priorityId = 'priorityId',
  postalCode = 'postalCode',
  localidad = '',
  latitude = 'latitude',
  longitude = 'longitude',
  incidentTime = 'incidentTime',
  beginDate = 'beginDate',
  endDate = 'endDate',
  orientId = 'orientId',
  brokerId = 'brokerId',
}

export interface IncidentsModel {
  divId: string;
  value: number;
  descriptionLabel: string;
  labelsClass: string;
}

export interface IncidentsCardModel {
  className: string
  incidentId: number
  stateName: string
  typeName: string
}

export interface IncidentStateStatModel {
  stateId: number,
  stateName: string,
  count: number
}

export interface Anotation {
  id: number,
  incidentId: number,
  observation: string,
  authorId: string,
  authorName: string,
  date: string,
}